<vectronic-card [title]="data.title">
  <ng-container body>
    <mat-dialog-content class="dialog-body">
      <p class="label">{{ data.bodyText }}</p>
    </mat-dialog-content>
    <mat-dialog-actions align="end" class="dialog-actions">
      <button mat-button color="primary" (click)="dialogRef.close()">
        <mat-icon>cancel</mat-icon>
        Cancel
      </button>
      <button mat-button color="warn" (click)="onDelete()">
        <mat-icon>delete</mat-icon>
        Delete
      </button>
    </mat-dialog-actions>
  </ng-container>
</vectronic-card>
